import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { success } from "../global/ToastAlert";
import { useGetVendorId } from "./../../hooks/global/User";
import api from '../../services/api';

const empty = {
    id: '',
    exclude_labels: null,
    answer_type: 'SCORE',
    origin: 'FEEDBACK',
    text: {},
    answer: null,
    group_id: null,
    labels: null,
    script: null,
    vendor_id:"",
}
export const useGetEmptyQuestion = () => {
    return {...empty}
}


export const useGetQuestionsList = (questionsList) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } = (questionsList) ? await api.get(`${process.env.REACT_APP_API_URL}/questions/list/?ids=${questionsList.join(',')}&vendorId=${vendorId}`) : { data: [] }
        return data;
    };
    return useQuery({ queryKey: ['questions', questionsList], queryFn: fetchData, enabled: true });
};

export const useGetQuestions = (moduleId) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } = (moduleId) ? await api.get(`${process.env.REACT_APP_API_URL}/modules/${moduleId}/questions/?vendorId=${vendorId}`) : { data: [] }
        return data;
    };
    return useQuery({ queryKey: ['questions', moduleId], queryFn: fetchData, enabled: true });
};

export const useGetQuestion = (questionId) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } = (questionId) ? await api.get(`${process.env.REACT_APP_API_URL}/modules/question/${questionId}/?vendorId=${vendorId}`) : { data: {...empty} }
        return data;
    };
    return useQuery({ queryKey: ['question', questionId], queryFn: fetchData, enabled: false });
};

export const useUpdateQuestion = (questionId, moduleId) => {

    const queryClient = useQueryClient();
    const vendorId = useGetVendorId();
    const updateData = async ({ data:updateData , message=null }) => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/modules/question/${questionId}/?vendorId=${vendorId}`, updateData)
        queryClient.invalidateQueries(['questions', moduleId]);
        success(message);
        return data;
    };
    return useMutation(updateData);
};

export const useInsertQuestion = () => {
    const queryClient = useQueryClient();
    const vendorId = useGetVendorId();
    const insertData = async ({ data:insertData, message = null} ) => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/questions/?vendorId=${vendorId}`, insertData);
        queryClient.invalidateQueries(['question', data.id]);
        success(message);
        return data;
    };

    return useMutation(insertData, {
        onSuccess: (data) => { }
    });
};

export const useDeleteQuestion = () => {
    const queryClient = useQueryClient();
    const vendorId = useGetVendorId();
    const deleteQuestion = async ({id, message=null}) => {
        await api.delete(`${process.env.REACT_APP_API_URL}/questions/${id}`);
        queryClient.invalidateQueries(['question', id]);
        success(message);
    };

    return useMutation(deleteQuestion);
};

export const useGetAvailableQuestions = () => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } = await api.get(`${process.env.REACT_APP_API_URL}/questions/?vendorId=${vendorId}`)
        return data;
    };
    return useQuery({ queryKey: ['allQuestions', vendorId], queryFn: fetchData, enabled: true });
};